module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-portal-4.bc8903e7.svg";